export const config = {
  title: 'W O Construction LLC',
  meta: {
    description:
      'W O Construction LLC offers premium construction services in Riverside, CA, executed by dedicated and experienced professionals.',
    keywords: [
      'Construction Services',
      'Home Renovation',
      'Building Contractors',
      'Riverside Construction',
      'W O Construction LLC',
    ],
    author: 'W O Construction LLC',
    canonicalUrl: 'https://woconstructionllc.com/',
  },
  sections: {
    header: {
      businessName: 'W O Construction LLC',
    },
    sectionB: {
      heroTitle: 'W O Construction LLC',
      heroSubtitle: 'Premium Construction Services in Riverside, CA',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '+13852304988',
      phoneLabel: '(385) 230-4988',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1406077905/photo/new-house-building-at-the-construction-site.jpg?s=612x612&w=0&k=20&c=DUpuARwIdKNEmt--VUNnFrb0s0AjiSWvyX85PhsdlcE=',
      cardData: [
        {
          title: 'Experienced Professionals',
          description:
            'Our team consists of dedicated professionals with extensive experience in the construction industry.',
        },
        {
          title: 'Quality Craftsmanship',
          description:
            'We deliver high-quality craftsmanship in every project, ensuring customer satisfaction.',
        },
        {
          title: 'Comprehensive Services',
          description:
            'From home renovations to new constructions, we offer a wide range of construction services.',
        },
      ],
      description:
        'W O Construction LLC specializes in premium construction services in Riverside, CA. Our dedicated and experienced professionals are committed to delivering high-quality craftsmanship in every project.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our range of professional construction services designed to bring your vision to life.',
      cards: [
        {
          title: 'Home Renovations',
          description:
            'Transform your home with our expert renovation services, tailored to your specific needs.',
          imageSrc: 'https://media.istockphoto.com/id/1477568555/photo/family-room-storing-tools-and-supplies.jpg?s=612x612&w=0&k=20&c=8hssqNuUoOwQ2bZvO0dR7Thdzn8CI6jSb9s-Aw_nvT8=',
          imageAlt: 'Home Renovations',
        },
        {
          title: 'New Construction',
          description:
            'We provide comprehensive new construction services, from planning to completion.',
          imageSrc: 'https://media.istockphoto.com/id/885566710/photo/interior-framing-of-a-new-house-under-construction.jpg?s=612x612&w=0&k=20&c=errnL4ClTzX0CfTc77nL6caMwyNiBgnYcjQCFlgco4M=',
          imageAlt: 'New Construction',
        },
        {
          title: 'Commercial Projects',
          description:
            'Our team handles commercial construction projects with professionalism and attention to detail.',
          imageSrc: 'https://media.istockphoto.com/id/1035150690/photo/construction-site-with-three-engineers-and-crane-on-the-top-of-new-skyscraper.jpg?s=612x612&w=0&k=20&c=33f1uM0uQYzJuIHPXiQXdClUZJXFHodVZBVz1694BUE=',
          imageAlt: 'Commercial Projects',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Project Management',
        'Consultation Services',
        'Custom Builds',
        'Remodeling',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/ivWtjr6YFASDUfLtqAMO/media/67d090db6df25735c9d8c1fe.png',
        alt: 'W O Construction LLC Team',
      },
      aboutText: [
        'W O Construction LLC is a Riverside, CA-based company incorporated on January 2, 2025. Our team of dedicated and experienced professionals is committed to delivering high-quality construction services.',
        'We specialize in a wide range of construction projects, from home renovations to new constructions, ensuring that each project is executed with utmost professionalism and attention to detail.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'W O Construction LLC Logo',
      businessName: 'W O Construction LLC',
      contact: {
        phone: '+13852304988',
        phoneLabel: '(385) 230-4988',
        email: 'info@woconstructionllc.com',
        website: 'https://woconstructionllc.com/',
        address: '4622 Tomlinson Ave, Riverside, CA 92503, United States',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: '4622 Tomlinson Ave, Riverside, CA 92503, United States',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3303.123456789012!2d-117.4123456!3d33.9123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcb1234567890%3A0xabcdef1234567890!2s4622%20Tomlinson%20Ave%2C%20Riverside%2C%20CA%2092503%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus',
    },
  },
};

export default config;
